<script>
import { authComputed, authMethods, trainerComputed, orgComputed, orgMethods } from '@state/helpers';

export default {
  name: 'TrainerOnboardingMobile',
  components: {},
  data() {
    return {
      email: '',
      password: '',
      placeholder: require('@assets/images/placeholder-avatar.png'),
    };
  },
  methods: {
    ...authMethods,
    ...orgMethods
  },
  computed: {
    ...authComputed,
    ...trainerComputed,
    ...orgComputed,
    trainerName() {
      return this.myTrainer.name;
    },
    trainerAvatarImage() {
      return this.myTrainer.mediaAssets.avatarImage.url || this.placeholder;
    },
    siteName(){
      return this.sitename;
    },
    siteLogoImage() {
      return this.darkLogoUrl;
    },
    certificationBadge() {
      return this.myTrainer &&
        this.myTrainer.public_bio &&
        this.myTrainer.public_bio.certificationBadges &&
        this.myTrainer.public_bio.certificationBadges.length > 0 &&
        this.myTrainer.public_bio.certificationBadges[0]
        ? this.myTrainer.public_bio.certificationBadges[0]
        : require('@assets/images/icons/issa-elite-trainer-certified.svg');
    },
  },
};
</script>

<template>
  <div class="container" v-if="myTrainer._id">
    <div id="meet-your-trainer">Meet Your Trainer</div>
    <div class="trainer-img">
      <img class="trainer-avatar" :src="trainerAvatarImage" alt="Trainer's face." />
    </div>
    <div id="trainer-name">
      {{ trainerName }}
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="myTrainer.public_bio.issaStudentData && myTrainer.public_bio.issaStudentData.MEMBERSHIPEXPIRATIONDATE !== undefined" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7.771 16L6.61 14.838l-1.524.615-.66-1.634h-1.92v-1.696l-1.72-.66.68-1.77L0 8.23l1.542-1.543-.817-2.022 1.78-.72V2.183h1.842L4.955.599l1.933.742L8.228 0l1.163 1.163 1.524-.616.661 1.635h1.92v1.695l1.72.66-.68 1.77L16 7.771l-1.543 1.543.817 2.022-1.779.72v1.763h-1.842l-.608 1.583-1.933-.742L7.772 16zM5.68 7.436l-.831.99 2.6 2.182.83-.99 2.917-3.355-.976-.849-2.93 3.372-1.61-1.35z" fill="#4059E1"/></svg>
    </div>
    <div id="issa-certified">{{
      myTrainer.public_bio.issaStudentData && myTrainer.public_bio.issaStudentData.MEMBERSHIPEXPIRATIONDATE !== undefined
        ? 'ISSA Certified'
        : ''
    }}</div>
    <div id="trainer-welcome">{{ myTrainer.public_bio.newClientWelcome }}</div>
    <div
      id="elite-logo"
      v-if="myTrainer.public_bio.issaStudentData && myTrainer.public_bio.issaStudentData.MEMBERSHIPEXPIRATIONDATE !== undefined"
    >
      <img svg-inline :src="certificationBadge" />
    </div>
    <div id="smartfitness-logo">
      <img :src="siteLogoImage" :alt="siteName" />
    </div>
    <div
      id="get-started"
      @click="userProfile && userProfile.successfulSignup ? $router.push({ name: 'home' }) : $router.push({ name: 'signUp' })"
    >
      <BaseButton class="large">
        <div>Get Started</div>
      </BaseButton>
    </div>
  </div>
</template>

// "public_bio": { // "isCertified": false, // "newClientWelcome": "Hey! So excited that you got the SmartFitness app set up and
are ready to get started!", // "issaStudentFound": null, // "issaStudentData": null // },

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-id-pattern
@media (min-width: 576px) {
  .modal-sm {
    max-width: 375px;
  }
}

.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  width: 100%;

  #meet-your-trainer {
    font-family: $secondary-font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
    line-height: 23px;
    margin-top: 20px;
  }

  .trainer-img {
    .trainer-avatar {
      border-radius: 100px;
      height: 180px;
      margin-bottom: 30px;
      object-fit: cover;
      padding: 10px;
      width: 180px;
    }
  }

  #trainer-name {
    font-family: $base-font-family;
    font-size: 35px;
    font-style: normal;
    font-weight: bold;
    line-height: 35px;
    position: relative;
    white-space: nowrap;
    svg {
      position: absolute;
    }
  }

  #issa-certified,
  #trainer-welcome {
    font-family: $secondary-font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: normal;
    line-height: 23px;
    margin: 0 auto 35px;
    text-align: center;
    width: 275px;
  }

  #elite-logo {
    margin-bottom: 100px;
    img {
      height: 50px;
      width: 70px;
    }
  }

  #smartfitness-logo {
    margin-bottom: 15px;
    img {
      width: 159.23px;
    }
  }

  #get-started {
    margin: 0 auto 20px;
    width: 85%;
  }
}
</style>
